import{DEFAULT_ALGOLIA_HIERARCHY_DIVIDER as s}from"@danfoss-source/search";const o=(o,r=s)=>{const c=o.split(r);return c.slice(1).map(((s,o)=>c.slice(0,o+1).join(r)))};export{o as getCategoryParents};
